var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyCheckoutDepositIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3947 5.72021H2.75732V22.3644H24.3947V5.72021ZM22.7303 20.7H4.42174V7.38463H22.7303V20.7Z",
    fill: "#F46A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0592 9.88135V24.0289H6.91846V25.6933H27.7237V9.88135H26.0592Z",
    fill: "#F46A6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.576 18.1233C15.6409 18.1233 17.3209 16.2957 17.3209 14.0493C17.3209 11.8029 15.6409 9.97534 13.576 9.97534C11.5111 9.97534 9.83105 11.8029 9.83105 14.0493C9.83105 16.2958 11.5111 18.1233 13.576 18.1233ZM13.576 11.6398C14.7232 11.6398 15.6565 12.7207 15.6565 14.0493C15.6565 15.3779 14.7232 16.4589 13.576 16.4589C12.4288 16.4589 11.4955 15.3779 11.4955 14.0493C11.4955 12.7207 12.4288 11.6398 13.576 11.6398Z",
    fill: "#F46A6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75035 9.46509H6.08594V18.6194H7.75035V9.46509Z",
    fill: "#F46A6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0658 9.46509H19.4014V18.6194H21.0658V9.46509Z",
    fill: "#F46A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyCheckoutDepositIconSvg);
export default __webpack_public_path__ + "static/media/policy-checkout-deposit-icon-svg.3e239f81.svg";
export { ForwardRef as ReactComponent };